import { DEFAULT_SCENARIOS, DEFAULT_TARGETS, emptyDeal } from './flip';
import type { AppData, Settings } from './types';

export const defaultSettings = (): Settings => ({
  targets: { ...DEFAULT_TARGETS },
  scenarios: structuredClone(DEFAULT_SCENARIOS),
  startingCash: 1000,
  defaults: emptyDeal(),
});

export const emptyData = (): AppData => ({ version: 1, settings: defaultSettings(), cars: [] });
